<div class="downloadAppArea">	
    <span class="homeSideBarHeader" [innerHTML]="'ACCOUNT_DOWNLOADAPP_TITLE' | translate"></span>
    <div class="home_qr_area">
        <div class="home_qr_areaBox">
            <img src="{{iosQRSrc}}">
            <span class="qrLabel" [innerHTML]="'ACCOUNT_DOWNLOADAPP_IOS_IMAGE' | translate"></span>
        </div>
         <div class="home_qr_areaBox">
            <img src="{{androidQRSrc}}">
            <span class="qrLabel" [innerHTML]="'ACCOUNT_DOWNLOADAPP_ANDROID_IMAGE' | translate"></span>
        </div>
    </div>
    <div class="home_qr_text">
        <span [innerHTML]="'ACCOUNT_DOWNLOADAPP_DESCRIPTION' | translate"></span>
    </div>
    <div class="homeRateArea">
        <span class="icon icon-fav"></span>
        <span class="icon icon-fav"></span>
        <span class="icon icon-fav"></span>
        <span class="icon icon-fav"></span>
        <span class="icon icon-fav"></span>
    </div>
</div>